import propOr from 'ramda/src/propOr'

import getRecordSelector from 'root/src/client/logic/api/selectors/getRecordSelector'

import { GET_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { getResponseLenses } from 'root/src/shared/descriptions/getEndpointDesc'

const responseLenses = getResponseLenses(GET_PROJECT)
const { pathOrGamesItem } = responseLenses

export default (state, props) => {
	const game = pathOrGamesItem(0, [], getRecordSelector(state, props))
	const gameImg = propOr(undefined, 'mobile', game)
	if (gameImg) {
		return gameImg
	}
	return propOr(
		'https://placehold.jp/24/cc9999/993333/{width}x{height}.png?text=Game',
		'boxArtTemplateUrl',
		game,
	)
}
